export default "__VITE_ASSET__YlohD87q__"